import SwapVerticalCircleRoundedIcon from '@mui/icons-material/SwapVerticalCircleRounded';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { Badge, Box, Input } from '@mui/material';
import { CustomTooltip } from '../../Utils/handler';

export const UpdateSequenceComponent = ({
    isSequence,
    setIsSequence,
    value,
    index,
    onClick
}) => {
    const handleSequenceInputChange = (e) => {
        const { name, value } = e.target;
        setIsSequence(prevState => ({
            ...prevState,
            [name]: value,
        }))
    };

    return (
        <Box display={'flex'} alignItems={'center'} width={'100px'}>
            {(isSequence?.open && isSequence?.idx === index) ?
                <Box display={'flex'} justifyContent={'center'} alignItems={'center'} gap={2}>
                    <Input
                        defaultValue={value?.indexNo}
                        inputProps={{ 'aria-label': 'description' }}
                        name='indexNo'
                        onChange={handleSequenceInputChange}
                    />
                    <TaskAltIcon
                        fontSize='small'
                        color='success'
                        sx={{ cursor: "pointer" }}
                        onClick={onClick}
                    />
                </Box>
                :
                <CustomTooltip title={'Update Sequence'}>
                    <Badge badgeContent={value?.indexNo} color="warning" sx={{
                        "& .MuiBadge-badge": {
                            height: '17px',
                            fontSize: '10px'
                        }
                    }}>
                        <SwapVerticalCircleRoundedIcon
                            color='primary'
                            fontSize='medium'
                            onClick={() => {
                                setIsSequence({ idx: index, open: true });
                            }}
                            sx={{ cursor: 'pointer' }}
                        />
                    </Badge>
                </CustomTooltip>
            }
        </Box>
    );
};